import { render, staticRenderFns } from "./RegisterSubNavigation.vue?vue&type=template&id=7a94f579&"
import script from "./RegisterSubNavigation.vue?vue&type=script&lang=js&"
export * from "./RegisterSubNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports